import React from 'react';
import { Box, Typography } from '@mui/material';

const LocationInformation = ({ title, locationFields, locationData }) => {
  return (
    <Box className="p-4 w-full rounded-md">
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      {locationFields.map((field) => (
          <Typography key={field.key} variant="body2">
            <strong>{field.label}:</strong> {locationData[field.key] || '-'}
          </Typography>
      ))}
    </Box>
  );
};

export default LocationInformation;
